import { create } from "zustand";
import { URL } from "../../lib/apis";

interface CartState {
  orderUser: any[];
  loadingOrderUser: boolean;
  fetchAllOrderUser: () => Promise<void>;
}

const userOrderUsers = create<CartState>((set) => ({
  orderUser: [], // Initialise à null avant le chargement des données
  loadingOrderUser: false,

  fetchAllOrderUser: async () => {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("user");

    if (!token) {
      console.error("User is not authenticated");
      return;
    }

    set({ loadingOrderUser: true });

    try {
      const response = await fetch(
        `${URL}/users/${userId}/orders`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch categories: ${response.statusText}`);
      }

      const data = await response.json();
      set({ orderUser: data.orders.reverse(), loadingOrderUser: false }); // On assigne directement 'data' sans 'data.data'
    } catch (error) {
      if (error instanceof Error) {
        console.error("Error fetching categories:", error.message);
      } else {
        console.error("Unknown error occurred");
      }
      set({ loadingOrderUser: false });
    }
  },
}));

export default userOrderUsers;
